const status = {
    general:[
        {
            id:0,
            label:'Inacivo',
            class: 'badge badge-soft-danger font-size-11'
        },
        {
            id:1,
            label:'Activo',
            class: 'badge badge-soft-success font-size-11'
        },
    ],
    youth_card_status:[
        {
            id:'inactive',
            label:'Inacivo',
            class: 'badge badge-soft-secondary font-size-11'
        },
        {
            id:'active',
            label:'En vigor',
            class: 'badge badge-soft-success font-size-11'
        },
        {
            id:'not_renewed',
            label:'No renovado',
            class: 'badge badge-soft-warning font-size-11'
        },
        {
            id:'discharged',
            label:'Baja',
            class: 'badge badge-soft-danger font-size-11'
        }, 
        {
            id:'cancelled',
            label:'Cancelado',
            class: 'badge badge-soft-danger font-size-11'
        },           
    ],
    yes_not:[
        {
            id:0,
            label:'No',
            class: 'badge badge-soft-danger font-size-11'
        },
        {
            id:1,
            label:'Sí',
            class: 'badge badge-soft-success font-size-11'
        },
    ],
    advantage_types:[
        {
            id:'physical',
            label:'Física',
            class: 'badge badge-soft-info font-size-11'
        },
        {
            id:'online',
            label:'Online',
            class: 'badge badge-soft-success font-size-11'
        },
    ],
    products:[
        {
            id:'draft',
            label:'Borrador'
        },
        {
            id:'pending',
            label:'Pendiente'
        },
        {
            id:'private',
            label:'Privado'
        },
        {
            id:'publish',
            label:'Publicado'
        }
    ],
    promotion_status:[
        {
            id:'draft',
            label:'Borrador',
            class: 'badge badge-soft-secondary font-size-11'
        },
        {
            id:'pending',
            label:'Pendiente',
            class: 'badge badge-soft-warning font-size-11'
        },
        {
            id:'private',
            label:'Privado',
            class: 'badge badge-soft-info font-size-11'
        },
        {
            id:'publish',
            label:'Publicado',
            class: 'badge badge-soft-success font-size-11'
        }
    ],
    advantage_status:[
        {
            id:'draft',
            label:'Borrador',
            class: 'badge badge-soft-secondary font-size-11'
        },
        {
            id:'pending',
            label:'Pendiente',
            class: 'badge badge-soft-warning font-size-11'
        },
        {
            id:'private',
            label:'Privado',
            class: 'badge badge-soft-info font-size-11'
        },
        {
            id:'publish',
            label:'Publicado',
            class: 'badge badge-soft-success font-size-11'
        }
    ],
    raffle_status:[
        {
            id:'draft',
            label:'Borrador',
            class: 'badge badge-soft-secondary font-size-11'
        },
        {
            id:'publish',
            label:'Publicado',
            class: 'badge badge-soft-success font-size-11'
        },
        {
            id:'completed',
            label:'Completado',
            class: 'badge badge-soft-info font-size-11'
        }
    ],
    raffle_types:[
        {
            id:'internal',
            label:'Interno',
            class: 'badge badge-soft-info font-size-11'
        },
        {
            id:'rrss',
            label:'Redes sociales',
            class: 'badge badge-soft-secondary font-size-11'
        }
    ],
    raffle_field_types:[
        {
            id:'text',
            label:'Texto',
        },
        {
            id:'date',
            label:'Fecha',
        },
        {
            id:'file',
            label:'Archivo',
        }
    ],
    raffle_visibility:[
        {
            id:'all',
            label:'Todos',
            class: 'badge badge-soft-success font-size-11'
        },
        {
            id:'app',
            label:'App móvil',
            class: 'badge badge-soft-info font-size-11'
        },
        {
            id:'web',
            label:'Sitio web',
            class: 'badge badge-soft-secondary font-size-11'
        }
    ],
    collaborator_status:[
        {
            id:'pending',
            label:'Pendiente',
            class: 'badge badge-soft-secondary font-size-11',            
        },
        {
            id:'approved',
            label:'Aprobado',
            class: 'badge badge-soft-success font-size-11'
        },
        {
            id:'rejected',
            label:'Rechazado',
            class: 'badge badge-soft-danger font-size-11'
        },
        {
            id:'cancelled',
            label:'Cancelado',
            class: 'badge badge-soft-danger font-size-11'
        }
    ],
    orders:[
        {
            id: 'pending',
            label: 'Pendiente',
            class: 'badge badge-soft-warning font-size-11'
        },
        {
            id: 'processing',
            label: 'Procesando',
            class: 'badge badge-soft-warning font-size-11'
        },
        {
            id: 'on-hold',
            label: 'En espera',
            class: 'badge badge-soft-warning font-size-11'
        },
        {
            id: 'completed',
            label: 'Completado',
            class: 'badge badge-soft-success font-size-11'
        },
        {
            id: 'cancelled',
            label: 'Cancelado',
            class: 'badge badge-soft-danger font-size-11'
        },
        {
            id: 'refunded',
            label: 'Reembolsado',
            class: 'badge badge-soft-danger font-size-11'
        },
        {
            id: 'failed',
            label: 'Fallido',
            class: 'badge badge-soft-danger font-size-11'
        }
    ],
    product_types:[
        {
            id:'simple',
            label:'Producto simple'
        },
        {
            id:'grouped',
            label:'Producto agrupado'
        },
        {
            id:'external',
            label:'Producto externo'
        },
        {
            id:'variable',
            label:'Producto variable'
        }
    ],
    product_tax_status:[
        {
            id:'taxable',
            label:'Sujeto a impuestos'
        },
        {
            id:'shipping',
            label:'Envío solamente'
        },
        {
            id:'none',
            label:'Ninguno'
        }
    ],
    stock_status:[
        {
            id:'instock',
            label:'Hay existencias'
        },
        {
            id:'outofstock',
            label:'Sin existencias'
        },
        {
            id:'onbackorder',
            label:'Se puede reservar'
        }
    ],
    backorder_status:[
        {
            id:'no',
            label:'No permitir'
        },
        {
            id:'notify',
            label:'Permitir, pero se avisará al cliente'
        },
        {
            id:'yes',
            label:'Permitir'
        }
    ],
    genders:[
        {
            id:'female',
            label:'Femenino'
        },
        {
            id:'male',
            label:'Masculino'
        },
        {
            id:'other',
            label:'Otro'
        }
    ],
    catalog_visibilities:[
        {
            id:'visible',
            label:'En la tienda y en los resultados de búsqueda'
        },
        {
            id:'catalog',
            label:'Solo en la tienda'
        },
        {
            id:'search',
            label:'Solo en los resultados de búsqueda'
        },
        {
            id:'hidden',
            label:'Oculto'
        }
    ],
    integration_product_import_status:[
        {
            id:0,
            label:'Pendiente'
        },
        {
            id:1,
            label:'Leyendo productos'
        },
        {
            id:2,
            label:'Guardando productos'
        },
        {
            id:3,
            label:'Sincronizando con WooCommerce'
        },
        {
            id:4,
            label:'Completado'
        },
        {
            id:5,
            label:'Sincronización fallida'
        },
    ],
    order_integration_status:[
        {
            id:'processing',
            label:'En proceso',
            class: 'badge badge-soft-warning font-size-11'
        },
        {
            id:'completed',
            label:'Completado',
            class: 'badge badge-soft-success font-size-11'
        },
        {
            id:'cancelled',
            label:'Cancelado',
            class: 'badge badge-soft-danger font-size-11'
        },
        {
            id:'failed',
            label:'Fallido',
            class: 'badge badge-soft-danger font-size-11'
        },
    ],
    coupon_discount_types:[
        {
            id:"fixed_cart",
            label:"Descuento fijo en el carrito"
        },
        {
            id:"percent",
            label:"Descuento en porcentaje"
        },
        {
            id:"fixed_product",
            label:"Descuento fijo por producto"
        },      
    ],
    card_application_statuses:[
        {
            id:"processing",
            label:"En proceso",
            class: 'badge badge-soft-warning font-size-11'
        },
        {
            id:"issued",
            label:"Emitido",
            class: 'badge badge-soft-info font-size-11'
        },
        {
            id:"completed",
            label:"Completado",
            class: 'badge badge-soft-success font-size-11'
        },        
        {
            id:"incomplete",
            label:"Solicitud incompleta",
            class: 'badge badge-soft-warning font-size-11'
        },      
        {
            id:"cancelled",
            label:"Cancelado",
            class: 'badge badge-soft-danger font-size-11'
        },      
        {
            id:"filed",
            label:"Archivado",
            class: 'badge badge-soft-danger font-size-11'
        },      
    ],
    card_application_paid_status:[
        {
            id:0,
            label:'Pendiente',
            class: 'badge badge-soft-warning font-size-11'
        },
        {
            id:1,
            label:'Pagado',
            class: 'badge badge-soft-success font-size-11'
        },
    ],
    youth_card_types:[
        {
            id:'classic',
            label:'Clásico',
            class: 'badge badge-soft-success font-size-11'
        },
        {
            id:'financial',
            label:'Financiero',
            class: 'badge badge-soft-info font-size-11'
        },
    ],
    shipping_types:[
        {
            id:"online",
            label:"Online",
            description: "Tramitación online"
        },
        {
            id:"carne_joven",
            label:"Carné Joven",
            description: "Oficina de Carné Joven"
        },
        {
            id:"ibercaja",
            label:"Ibercaja",
            description: "Oficina de Ibercaja"
        },      
        {
            id:"caja_rural_aragon",
            label:"Caja Rural Aragón",
            description: "Oficina de Caja Rural Aragón"
        },      
        {
            id:"caja_rural_teruel",
            label:"Caja Rural Teruel",
            description: "Oficina de Caja Rural Teruel"
        },      
    ],
    template_types:[
        {
            id:"youth_card_payment",
            label:"Carta de pago",
        },     
        {
            id:"youth_card",
            label:"Carné",
        },     
        {
            id:"youth_card_shipping",
            label:"Carta de envío",
        },     
        {
            id:"raffle_winner_email",
            label:"Ganador de sorteo",
        },     
    ],
    email_template_types:[
        {
            id:"card_payment_online",
            label:"Solicitud carné - pago Online",
        },     
        {
            id:"card_payment_bank",
            label:"Solicitud carné - pago en Cajas",
        },     
        {
            id:"card_payment_office",
            label:"Solicitud carné - pago Oficina Carné Joven",
        },   
        {
            id:"card_application_children",
            label:"Solicitud carné gratuito 12-13 años",
        },   
        {
            id:"card_application_children_completed",
            label:"Solicitud carné gratuito 12-13 años completada",
        },   
        {
            id:"card_application_completed",
            label:"Carné completado",
        },     
        {
            id:"collaborator_registered",
            label:"Colaborador registrado",
        },     
        {
            id:"collaborator_approved",
            label:"Colaborador aprobado",
        },     
    ],
    promotion_modality_types:[
        {
            id:"amount",
            label:"Valor",
        },     
        {
            id:"percentage",
            label:"Porcentaje",
        },     
    ],
    years_old_list:[
        {
            id:"under_26_years_old",
            label:"Menor a 26 años",
        },     
        {
            id:"over_26_years_old",
            label:"Mayor a 26 años",
        },     
    ],
    card_application_operation_types:[
        {
            id:"registration",
            label:"Alta",
        },     
        {
            id:"renewal",
            label:"Renovación",
        },     
    ],
    discount_code_types:[
        {
            id:"unique",
            label:"Único",
        },     
        {
            id:"per_holder",
            label:"Por titular",
        },     
        {
            id:"per_modality",
            label:"Por titular por modalidad",
        },     
    ],
    revised_status:[
        {
            id:0,
            label:'No revisado',
            class: 'badge badge-soft-warning font-size-11'
        },
        {
            id:1,
            label:'Revisado',
            class: 'badge badge-soft-success font-size-11'
        },
    ],
    eyca_sync_status:[
        {
            id:'no_syncronized',
            label:'No sincronizado',
            class: 'badge badge-soft-default font-size-11'
        },
        {
            id:'syncronized',
            label:'Sincronizado',
            class: 'badge badge-soft-green font-size-11'
        },
        {
            id:'syncronized_error',
            label:'Sincronizado con error',
            class: 'badge badge-soft-danger font-size-11'
        },
    ],
    sync_log_status:[
        {
            id:'pending',
            label:'Pendiente',
            class: 'badge badge-soft-secondary font-size-11'
        },
        {
            id:'processing',
            label:'Procesando',
            class: 'badge badge-soft-info font-size-11'
        },
        {
            id:'success',
            label:'Exitoso',
            class: 'badge badge-soft-success font-size-11'
        },
        {
            id:'failed',
            label:'Fallido',
            class: 'badge badge-soft-danger font-size-11'
        },
        {
            id:'retrying',
            label:'Reintentando',
            class: 'badge badge-soft-warning font-size-11'
        },
    ],
    sync_log_direction:[
        {
            id:'outbound',
            label:'Saliente',
            class: 'badge badge-soft-success font-size-11'
        },
        {
            id:'inbound',
            label:'Entrante',
            class: 'badge badge-soft-info font-size-11'
        },
    ],
    sync_log_operation:[
        {
            id:'create',
            label:'Crear',
            class: 'badge badge-soft-info font-size-11'
        },
        {
            id:'update',
            label:'Actualizar',
            class: 'badge badge-soft-warning font-size-11'
        },
        {
            id:'delete',
            label:'Eliminar',
            class: 'badge badge-soft-danger font-size-11'
        },
    ],
}

export default {
    getStatus({itemStatus, type, html = false, title = ''}) {
        const item = status[type]?.find(({id}) => id == itemStatus);
        return (html) ? `<span class="${item?.class}" title="${title}">${item?.label}</span>` : item?.label;
    },
    getList(type) {
        return status[type];
    }
};